import { animateScroll as scroll } from "react-scroll";

export function screenToTop() {
  window.screenTop();
}

export function scrollTop() {
  scroll.scrollToTop();
}
